export { default } from './FareTableContainer';
